import { css } from 'lit';

/** v1.2 ITRADE Biohacks Registry catalog grid — matches biohacks-store v1.2 reference. */
export const biohacksRegistryStyles = css`
  .catbar {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin: 0 0 32px;
  }

  .chip {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11.5px;
    letter-spacing: 0.04em;
    padding: 9px 15px;
    border: 1px solid var(--line, rgba(126, 200, 227, 0.14));
    background: var(--bg-2, #0a1420);
    color: var(--muted, #9fb2bf);
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
  }

  .chip:hover {
    border-color: var(--line-gold, rgba(245, 200, 66, 0.32));
    color: var(--text, #f0ede8);
  }

  .chip.sel {
    border-color: var(--teal, #35e6d0);
    background: var(--teal-soft, rgba(53, 230, 208, 0.12));
    color: var(--teal, #35e6d0);
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
  }

  @media (max-width: 1100px) {
    .grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  @media (max-width: 1024px) {
    .grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 560px) {
    .grid {
      grid-template-columns: 1fr;
    }
  }

  .prod {
    background: linear-gradient(165deg, var(--panel, #0e1a24), var(--bg-2, #0a1420));
    border: 1px solid var(--line, rgba(126, 200, 227, 0.14));
    display: flex;
    flex-direction: column;
    transition: all 0.28s;
    position: relative;
    overflow: hidden;
    height: 100%;
  }

  .prod::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, var(--teal, #35e6d0), var(--gold, #f5c842));
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.35s;
  }

  .prod:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow, 0 30px 80px -42px rgba(0, 0, 0, 0.85));
    border-color: var(--line-teal, rgba(53, 230, 208, 0.38));
  }

  .prod:hover::before {
    transform: scaleX(1);
  }

  .prod .pimg {
    height: 210px;
    min-height: 210px;
    max-height: 210px;
    flex-shrink: 0;
    overflow: hidden;
    background:
      radial-gradient(circle at 50% 42%, rgba(53, 230, 208, 0.07), transparent 68%),
      var(--landi-image-bg, var(--bg-2, #0a1420));
    border-bottom: 1px solid var(--line, rgba(126, 200, 227, 0.14));
    position: relative;
  }

  .prod .pimg landi-product-image {
    display: block;
    width: 100%;
    height: 100%;
  }

  .prod .pimg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  .prod .pcat2 {
    position: absolute;
    top: 12px;
    right: 12px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 8.5px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--teal, #35e6d0);
    background: #0b1620;
    border: 1px solid var(--line-teal, rgba(53, 230, 208, 0.38));
    padding: 5px 9px;
    max-width: 62%;
    text-align: right;
    opacity: 0;
    transform: translateY(-6px);
    transition: opacity 0.28s ease, transform 0.28s ease;
    pointer-events: none;
    box-shadow: 0 6px 18px -8px rgba(0, 0, 0, 0.7);
  }

  .prod:hover .pcat2 {
    opacity: 1;
    transform: translateY(0);
  }

  .prod .body {
    padding: 6px 20px 0;
    cursor: pointer;
    flex: 1;
  }

  .prod h3 {
    font-family: 'JetBrains Mono', monospace;
    font-size: 19px;
    font-weight: 700;
    letter-spacing: 0;
    color: var(--text, #f0ede8);
    line-height: 1.1;
    margin: 0;
  }

  .prod .sub {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    color: var(--muted-2, #66808f);
    margin-top: 6px;
    letter-spacing: 0.02em;
    line-height: 1.4;
  }

  .prod .spec {
    display: flex;
    gap: 14px;
    margin-top: 14px;
    padding-top: 12px;
    border-top: 1px solid var(--line, rgba(126, 200, 227, 0.14));
  }

  .prod .spec div .k {
    font-family: 'JetBrains Mono', monospace;
    font-size: 8.5px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--muted-2, #66808f);
  }

  .prod .spec div .v {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    color: var(--text, #f0ede8);
    margin-top: 2px;
  }

  .prod .spec div .v.teal {
    color: var(--teal, #35e6d0);
  }

  .prod .foot {
    padding: 16px 20px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-top: 14px;
  }

  .prod .price {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 28px;
    color: var(--gold, #f5c842);
    line-height: 1;
  }

  .prod .price small {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    color: var(--muted-2, #66808f);
    letter-spacing: 0.04em;
  }

  .add {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #04231f;
    background: var(--teal, #35e6d0);
    border: 1px solid var(--teal, #35e6d0);
    padding: 9px 14px;
    cursor: pointer;
    transition: all 0.2s;
    font-weight: 700;
  }

  .add:hover {
    background: var(--gold, #f5c842);
    border-color: var(--gold, #f5c842);
  }

  .add.added {
    background: var(--panel, #0e1a24);
    color: var(--teal, #35e6d0);
    border-color: var(--teal, #35e6d0);
  }
`;
